module.exports = __webpack_public_path__ + "static/assets/961bfad11616b6f5c951c58499cf267a.mp3";